import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ca478b3c")

_pushScopeId("data-v-ca478b3c")
const _hoisted_1 = {
  class: "p-col-12 p-md-6 p-lg-4 p-xl-3",
  tabindex: "0"
}
const _hoisted_2 = { class: "card-container" }
const _hoisted_3 = { class: "details-container" }
const _hoisted_4 = {
  class: "p-ml-3 detail-type",
  role: "type"
}
const _hoisted_5 = { class: "p-ml-3 detail-info" }
const _hoisted_6 = { class: "detail-buttons" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Menu = _resolveComponent("Menu")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.document[_ctx.documentFields.type]), 1),
          _createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("h4", {
              class: "p-m-0 kn-truncated",
              role: "title"
            }, _toDisplayString(_ctx.document[_ctx.documentFields.label]), 513), [
              [_directive_tooltip, _ctx.document[_ctx.documentFields.label]]
            ]),
            _withDirectives(_createVNode("p", { class: "p-m-0 kn-truncated" }, _toDisplayString(_ctx.document[_ctx.documentFields.name]), 513), [
              [_directive_tooltip, _ctx.document[_ctx.documentFields.name]]
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.documentButtons, (button, index) => {
              return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                (button.visible)
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      id: button.id,
                      icon: button.icon,
                      class: "p-mx-1 p-button-text p-button-rounded p-button-plain p-button-lg",
                      onClick: button.command,
                      "aria-label": _ctx.$t(button.label)
                    }, null, 8, ["id", "icon", "onClick", "aria-label"])), [
                      [_directive_tooltip, _ctx.$t(button.label)]
                    ])
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]),
        (_ctx.document[_ctx.documentFields.image])
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              "aria-hidden": "true",
              class: "card-image",
              style: [_ctx.documentImageSource]
            }, null, 4))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              "aria-hidden": "true",
              class: "card-image",
              style: [_ctx.documentImageSource]
            }, null, 4))
      ])
    ]),
    _createVNode(_component_Menu, {
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"])
  ], 64))
})